type QueryConfig = {
  query: string;
  variables: any;
};

export const getUserQuery = (
  userId: string,
  customerId?: string
): QueryConfig => {
  const query = `query getUser($userId: ID, $customerId: ID) {
            user(id: $userId) {
                id, displayedLoginName, actualLoginName,
                active,
                userSegments {
                  accelerateAdmin
                }
                userDemographic {
                    firstName, lastName, email, phone, birthDate, gender
                },
                userPreferences { userId, key, value },
                customer { id, baseLocation { id } }
                assignedSolutions {
                  id
                  name
                  nameToken
                  label
                  code
                  icon
                  applications {
                    id
                    assigned
                    accelerateNative
                    applicationName
                    applicationCode
                    redirectUrl
                    capabilityPath
                    relativeApplicationPath
                    embedUrl
                    marketingUrl
                  }
                }
                availableSolutions {
                  id
                  name
                  nameToken
                  label
                  code
                  icon
                  applications {
                    id
                    assigned
                    accelerateNative
                    applicationName
                    applicationCode
                    redirectUrl
                    capabilityPath
                    relativeApplicationPath
                    embedUrl
                    marketingUrl
                  }
                }
                assignedApplications {
                  id
                  applicationName
                  applicationCode
                  redirectUrl
                  solutionName
                  capabilityPath
                  relativeApplicationPath
                  embedUrl
                }
                availableApplications {
                  applicationName
                  applicationCode
                  solutionName
                  assigned
                  marketingUrl
                  accelerateNative
                }
                assignedAdminApplications {
                  name
                  redirectUrl
                }
                permissions { 
                    accelerate(customerId: $customerId) {
                        canViewAdminMenu, canViewEhsConfig, canViewUsers, canEditUsers, canViewMyProfile, canViewCustomers, canEditCustomers
                        canViewAppConfig, canEditAppConfig, canDeleteAppConfig, canEditSSO
                        canDeleteSSO, canViewSSO, canViewRole, canViewPolicy
                        canEditRole, canAssignRole, canAssignApplications, canViewUnpurchased,
                        canViewLocationsMenu, canViewHierarchiesMenu, canManageUserPreferences,
                        canEditPersons, canViewPersons, canViewSensitiveData, canEditSensitiveData, canManageEhsRoles, canViewContractingCompanies, canEditContractingCompanies, canExploreReportingData
                    } 
                }
            } 
        }`;
  return {
    query: query,
    variables: {
      userId: userId,
      customerId: customerId,
    },
  };
};

export const getCustomerQuery = (customerId: string) => {
  const query = `query getCustomer($customerId: ID, $applicationsPaginationInput: PaginationInput) {
            customer(id: $customerId) {
              id
              customerDomainName
              name
              velocityEhsCustomerNumber
              customerOu
              numberOfUsers
              active
              applications(paginationInput: $applicationsPaginationInput) {
                items {
                  id
                  name
                  code
                  isAssigned
                  bundle {
                    name
                  }
                }
              }
            }
        }`;
  return {
    query: query,
    variables: {
      customerId: customerId,
      applicationsPaginationInput: {
        pageSize: 1000,
      },
    },
  };
};

export const locationsUserPermissionsQuery = (
  userId: string,
  customerId: string
): QueryConfig => {
  const query = `query locationsUserPermissions($userId: ID!, $customerId: ID!) {
            locations_user(userId: $userId, customerId: $customerId) {
                canManageLocations
                canManageOrgHierarchies
            }
        }`;
  return {
    query: query,
    variables: {
      userId,
      customerId,
    },
  };
};
